window.theme = window.theme || {};

/* ================ REGISTER ================ */

/* 承認チェック */
$(function () {
  var agree = $('.btn-next');
  agree.disabled = true;

  $('.btn_agree').click(function () {
    if (this.checked) {
      agree.disabled = false;
      agree.addClass('active');
    } else {
      agree.disabled = true;
      agree.removeClass('active');
    }
  });

  $('.btn-next').on('click', function () {
    if (!agree.disabled) {
      $('.part-terms').hide('fast');
      $('.part-from').show('fast');
      $('.page-process li').eq(1).addClass('page-on');
      $('html,body').animate({ scrollTop: 0 }, 'fast');
    }

    return false;
  });

  /* フォームバリデーション チェック */
  var onConfirm = $('.btn-form');
  onConfirm.disabled = true;
  $('#form input').change(function () {
    if ($('#form')[0].reportValidity()) {
      var pass_1 = $('#RegisterForm-password').val();
      var pass_2 = $('#RegisterForm_re-password').val();
      if (pass_1 === pass_2) {
        if (onConfirm.disabled == true) {
          onConfirm.disabled = false;
          onConfirm.addClass('active');
        }
      } else {
        onConfirm.disabled = true;
        onConfirm.removeClass('active');
        $('#RegisterForm_re-password').setCustomValidity(
          '入力したパスワードが違っています。'
        );
      }
    }
  });

  onConfirm.on('click', function () {
    if (!onConfirm.disabled) {
      var pass_1 = $('#RegisterForm-password').val();
      var pass_2 = $('#RegisterForm_re-password').val();
      if (pass_1 === pass_2) {
        if ($('#form')[0].reportValidity()) {
          $('.part-from').hide('fast');
          $('.part-confirm').show('fast');
          $('.page-process li').eq(2).addClass('page-on');
          var lastname = $('#RegisterForm-LastName').val();
          $('#RegisterForm-LastName1').val(lastname);
          $('#Name2').html(lastname);
          var firstname = $('#RegisterForm-FirstName').val();
          $('#RegisterForm-FirstName1').val(firstname);
          $('#Name2').append(' ' + firstname);

          var email = $('#RegisterForm-email').val();
          $('#Email1').val(email);
          $('#Email2').html(email);

          var pswd = $('#RegisterForm_re-password').val();
          $('#Password1').val(pswd);
          $('html,body').animate({ scrollTop: 0 }, 'fast');
        }
      }
    }

    return false;
  });

  $('.btn-back').on('click', function () {
    $('.part-confirm').hide('fast');
    $('.part-from').show('fast');
    $('.page-process li').eq(2).removeClass('page-on');
    $('html,body').animate({ scrollTop: 0 }, 'fast');
  });

  //about page custom//
  $('.marker').on('click', function () {
    if ($(this).children().hasClass('active')) {
      $(this).children().removeClass('active');
      $(this).children('.more-text').text('More');
    } else {
      $(this).children().addClass('active');
      $(this).children('.more-text').text('Close');
    }
    $(this).parent().find('.sp-close').slideToggle();
  });

  slider_open();

  $(window).on('load resize', function () {
    slider_open();
  });

  //商品売場セレクトの設定
  var url = new URL(window.location.href);
  if (url.searchParams.get('contents') == '350') {
    $('#SingleOptionSelector-0').val('350mL');
    $("#SingleOptionSelector-0 option[value='350mL']").prop('selected', true);
  }

  // shoplist page アコーディオン
  $('.list-title').on('click', function () {
    $(this).children('.list-title-toggle-button').toggleClass('active');
    $(this).next('.list-content-wrap').slideToggle();
  });
});

function slider_open() {
  var w_w = $(window).width();
  var path = location.pathname;

  if (path === '/pages/about' && w_w < 1024) {
    $('.features-wrapper').slick({
      dots: true,
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 1,
    });
  }

  if (path === '/' && w_w <= 749) {
    $('.sectionHeader-slider').slick({
      infinite: true,
      dots: true,
      centerPadding: '20%',
      slidesToShow: 1.4,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
    });
  } else if (path === '/' && w_w >= 750) {
    $('.sectionHeader-slider').slick({
      infinite: true,
      dots: true,
      centerPadding: '20%',
      slidesToShow: 2.4,
      slidesToScroll: 1,
      centerMode: true,
      variableWidth: true,
    });
  }

  if (path === '/' && w_w <= 749) {
    $('#js-top-shoplist ul, #top-media ul').slick({
      dots: true,
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 1,
    });
  }

  if (path === '/') {
    $('.fv-image ul').slick({
      dots: true,
      centerMode: true,
      speed: 800,
      fade: true,
      arrows: false,
      centerPadding: '60px',
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  }

  if (typeof $('#headerCarousel') !== 'undefined') {
    $('#headerCarousel').slick({
      infinite: true,
      autoplay: true,
      speed: 5000,
      fade: true,
      arrows: false,
      autoplaySpeed: 1500,
      dots: true,
    });
  }
}
var readButton = document.querySelector('.secretItem_btn-read');
var closeButton = document.querySelector('.secretItem_btn-close');
var textContent = document.querySelector('.secretItem_text-main');

// "READ" ボタンがクリックされたときに実行
readButton.addEventListener('click', function () {
  closeButton.style.display = 'block';
  readButton.style.display = 'none';
  textContent.style.display = 'block';
});

// "CLOSE" ボタンがクリックされたときに実行
closeButton.addEventListener('click', function () {
  closeButton.style.display = 'none';
  readButton.style.display = 'block';
  textContent.style.display = 'none';
});

// アンカーリンク
$(document).ready(function () {
  const url = window.location.href;

  const setHeaderHeight = function () {
    let headerHeight;

    const headerElement = $('[data-section-id="header"]');

    if (headerElement.length > 0) {
      headerHeight = headerElement.outerHeight();
    } else {
      headerHeight = 60;
    }

    if ($(window).width() >= 749) {
      headerHeight += 15;
    } else {
      headerHeight -= 250;
    }

    return headerHeight;
  };

  if (url.indexOf('#') !== -1) {
    const anchor = url.split('#');
    const target = $('#' + anchor[anchor.length - 1]);

    const headerHeight = setHeaderHeight();

    const position = Math.floor(target.offset().top);
    const scrollPosition = position - headerHeight;

    $('html, body').animate({ scrollTop: scrollPosition }, 500);
  }
});
